import React from 'react';
// import data
// import { copyright, footer } from '../data';
import { footer } from '../data';
// import components
import Copyright from '../components/Copyright';
import { Link } from 'react-router-dom';
import { AiFillYoutube, AiFillFacebook, AiFillInstagram } from "react-icons/ai"
import { FaTelegram} from 'react-icons/fa'

const Footer = () => {
  // destructure footer data
  const { logo, links, legal, newsletter, form } = footer;
  // const { social } = copyright
  return (
    <footer className='pt-[142px] pb-[60px] bg-sky-900 text-white'>
      <div className='container mx-auto'>
        <div className='flex flex-col items-center text-center lg:flex-row lg:items-start lg:text-left lg:justify-between gap-y-8'>
          {/* logo */}
          <div data-aos='fade-up' data-aos-offset='200' data-aos-delay='300' className='relative'>
            <img src={logo} alt='logo' className='w-[90px] h-[90px] m-1' />
            <p className='mt-3 text-sm text-justify relative'>Trading made easy.<br />
              With our expert advisor,<br />
              Everyone can trade.</p>
            {/* social icons */}
            <ul className='flex gap-x-[12px] mt-4 cursor-pointer'>
              {/* {social.map((item, index) => {
                // destructure icon
                const { href, icon } = item;
                return (
                  <li key={index}>
                    <a href={href}>
                      <img src={icon} alt='icon' />
                     
                    </a>
                    
                  </li>
                );
               
              })} */}



              <a href='https://www.facebook.com/groups/traderdoph'  target='_new' rel='noreferrer'>
                <AiFillFacebook />
              </a>
              <a href='https://www.youtube.com/channel/UCxwLlu6rT-R7bo0_X6xEtKw'  target='_new' rel='noreferrer'>
                <AiFillYoutube />
              </a>
              <a href='https://www.instagram.com/traderdoph20/'  target='_new' rel='noreferrer'>
                <AiFillInstagram />
              </a>
              <a href='https://t.me/TraderDoPhOfficial'  target='_new' rel='noreferrer'>
              <FaTelegram/>
              </a>
             




            </ul>
          </div>
          {/* list 1 */}
          <div data-aos='fade-up' data-aos-offset='200' data-aos-delay='500'>
            <div className='text-2xl uppercase font-medium mb-6 animate-bounce'>Useful Links</div>

            <ul className='flex flex-col gap-y-3'>
              {links.map((item, index) => {
                // destructure item
                const { href, name } = item;
                return (
                  <li key={index}>
                    <Link
                      className='font-medium hover:text-sky-300 transition'
                      to={href}
                    >
                      {name}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
          {/* list 2 */}
          <div data-aos='fade-up' data-aos-offset='200' data-aos-delay='700'>
            <div className='text-2xl uppercase font-medium mb-6 animate-bounce'>Legal</div>
            <ul className='flex flex-col gap-y-3'>
              {legal.map((item, index) => {
                // destructure item
                const { href, name } = item;
                return (
                  <li key={index}>
                    <Link
                      className='font-medium hover:text-sky-300 transition '
                      to={href}
                    >
                      {name}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
          {/* newsletter */}
          <div data-aos='fade-up' data-aos-offset='200' data-aos-delay='900'>
            <div className='text-2xl uppercase font-medium mb-6 '>
              {newsletter.title}
            </div>
            <div className='text-xl text-light mb-[18px]'>
              {newsletter.subtitle1} <br /> {newsletter.subtitle2}
            </div>
            {/* form */}
            <form className='max-w-[349px] mb-[10px]'>
              <div className='h-[62px] p-[7px] flex border border-dark rounded-lg'>
                <input
                  className='w-full h-full pl-6 border-none outline-none placeholder:text-dark text-black'
                  type='email'
                  placeholder={form.placeholder}
                />
                <button className='btn btn-sm bg-sky-400 hover:bg-sky-300 w-[102px] text-black justify-center items-center hover:text-white'>

                  <Link to='/' className=' animate-pulse' >
                    {form.btnText}
                  </Link>

                </button>
              </div>
            </form>
            <span className='text-sm text-light'>{form.smallText}</span>
          </div>
        </div>
        <hr
          className='mt-10 mb-5'
          data-aos='fade-up'
          data-aos-offset='100'
          data-aos-delay='200'
        />
        <Copyright />
      </div>
    </footer>
  );
};

export default Footer;
